/**
 * Takes a canvas crop area from react-easy-crop and returns
 * a File object ready to pass to the upload service.
 */
export async function getCroppedImageFile(
  imageSrc,
  pixelCrop,
  fileName = "cropped.jpg",
  slotType = "GALLERY",
) {
  const image = await createImageBitmap(await fetch(imageSrc).then((r) => r.blob()));

  const canvas = document.createElement("canvas");
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height,
  );

  const isLogoSlot = ["NAVBAR_LOGO", "LOGO"].includes(slotType);
  const mimeType = isLogoSlot ? "image/png" : "image/jpeg";
  const quality = isLogoSlot ? undefined : 0.92;
  const extension = isLogoSlot ? "png" : "jpg";
  const outName = fileName.replace(/\.[^.]+$/, "") + "." + extension;

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Canvas toBlob failed"));
          return;
        }
        resolve(new File([blob], outName, { type: mimeType }));
      },
      mimeType,
      quality,
    );
  });
}

// slot config
export const SLOT_CROP_CONFIG = {
  NAVBAR_LOGO: {
    aspect: 3 / 1, // 300×100
    label: "Crop logo",
    hint: "Best at 3:1 — wide and short",
  },
  LOGO: {
    aspect: 1 / 1, // 400×400 square
    label: "Crop logo",
    hint: "Best as a square",
  },
  BANNER: {
    aspect: 16 / 9, // 1920×800 ≈ 2.4:1, 16:9 is close enough
    label: "Crop banner",
    hint: "Wide landscape — 16:9",
  },
  PROFILE_PHOTO: {
    aspect: 1 / 1, // 800×800 square
    label: "Crop photo",
    hint: "Square works best for profile photos",
  },
  GALLERY: {
    aspect: 4 / 3, // flexible
    label: "Crop image",
    hint: "4:3 landscape",
  },
};

export function getCropConfig(slotType) {
  return SLOT_CROP_CONFIG[slotType] ?? { aspect: 4 / 3, label: "Crop image", hint: "" };
}